/**
 * @generated SignedSource<<46c5964e0838a5f836ebdbdec1540cb6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FirstClientXeroConnectionChoices_integration$data = {
  readonly rowId: any;
  readonly config: any | null;
  readonly " $fragmentType": "FirstClientXeroConnectionChoices_integration";
};
export type FirstClientXeroConnectionChoices_integration$key = {
  readonly " $data"?: FirstClientXeroConnectionChoices_integration$data;
  readonly " $fragmentSpreads": FragmentRefs<"FirstClientXeroConnectionChoices_integration">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FirstClientXeroConnectionChoices_integration",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "config",
      "storageKey": null
    }
  ],
  "type": "Integration",
  "abstractKey": null
};

(node as any).hash = "535857800a2bfe9906fc2b39d634d823";

export default node;
